import { ContactService } from './../../core/services/contact/contact.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CCreateEntreprise } from './../../core/models/entreprise';
import { contactintrouvable, emailSended } from './../../core/models/messages';
import { LocalStorageService } from './../../core/services/local-storage.service';

import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReCaptchaService } from '@shared/services/reCaptcha.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css'],
})
export class ContactComponent {
  contactEsnForm!: FormGroup;
  currentUser: any;
  id: any;
  filtered: any;
  submitted = false;
  listContactNames: any;
  type:any;
  disableBtn :boolean = true;
    isspinner: boolean = false;
  types = [
    { value: 'Technique', id: '1' },
    { value: 'Service client', id: '2' },
    { value: 'Réclamation', id: '3' },
  ];

  selected: any = this.types[0];
  file: any;
  idResponsable: any;
  constructor(
    private contactService: ContactService,
    private localStorageService: LocalStorageService,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private router: Router,
    private reCaptchaService: ReCaptchaService,
  ) {
    this.currentUser = new CCreateEntreprise();
  }
  toolbarOptions = [
    ['bold', 'italic', 'underline'], // toggled buttons
    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ color: [] }, { background: [] }], // outdent/indent
    ['clean'], // remove formatting button
  ];
  ngOnInit() {
    this.currentUser = this.localStorageService.getData('dataUser');
    // this.id = JSON.parse(this.currentUser).id
    this.getId();
    this.contactEsnFormGroup();
    this.getContactNames()
  }
  fileName: string = '';
  resetFile() {
    const inputFile = document.getElementById('cv_file') as HTMLInputElement;
    if (inputFile) {
      inputFile.value = '';
    }
    this.file = null;
    this.fileName = '';
  }
  /* get id esn */
  getId() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.idResponsable = params.params['idResponsable'];
        this.type = params.params['Type']
      },
    });
  }

  contactEsnFormGroup(data?: any) {
    this.contactEsnForm = this.formBuilder.group({
      // type: [this.types[1].id],
      
      object: ['', [Validators.required, Validators.maxLength(100)]],
      subject: ['',Validators.required],
      user_id: [''],
      esn_id: this.idResponsable,

      file: [''],
    });
      if (this.type === '1') {
    this.contactEsnForm.addControl('mailing_id', this.formBuilder.control(data?.mailing_id ?? null, Validators.required));
  } else if (this.type === '2') {
    this.contactEsnForm.addControl('type', this.formBuilder.control(data?.type ?? null, Validators.required));
  }
  }

  onFileChange(event: Event) {
    const fileInput = event.target as HTMLInputElement;
    if (fileInput.files && fileInput.files[0]) {
      const file = fileInput.files[0];
      this.file = file;
      this.contactEsnForm.get('file')?.setValue(this.file);
    }
  }
contact(){
    if(this.type=='1'){
     this.contactEsn()
    }else{
     this.contactResponsable()
    }
  }
  contactEsn() {
    if (this.contactEsnForm.invalid) {
      return;
    }
      this.reCaptchaService.executeAction('contactEsn').then(token => {
      this.spinner.show();
      this.submitted = true;
      const formData = new FormData();
      if(this.contactEsnForm.get('mailing_id')?.value){
        formData.append(
          'mailing_id',
          this.contactEsnForm.get('mailing_id')?.value
        );
      }

      formData.append('object', this.contactEsnForm.get('object')?.value);
      formData.append('subject', this.contactEsnForm.get('subject')?.value);
      formData.append('esn_id', this.contactEsnForm.get('esn_id')?.value);
      formData.append('file', this.contactEsnForm.get('file')?.value);
      formData.append('recaptchaToken', token);

      const formDataObject: { [key: string]: any } = {};
      formData.forEach((value, key) => {
        formDataObject[key] = value;
      });

      this.contactService
        .contactEsn(formData)
        .pipe()
        .subscribe({
          next: (res) => {
            this.spinner.hide();
            this.toastrService.success(emailSended);
            this.onReset();
            this.router.navigate(['/wegestu/entreprises/details', { id:  this.idResponsable}])
          },
          error: (err) => {
            this.spinner.hide();
            if (err?.error) {
              this.toastrService.error(' "Cette entreprise n`\'a pas de responsable!"');
            }
          },
        });
      }).catch(err => {
        this.spinner.hide();
        this.toastrService.error('reCAPTCHA verification failed. Please try again.');
      });
  }
  contactResponsable() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.contactEsnForm.invalid) {
      return;
    }
    this.reCaptchaService.executeAction('contactResponsable').then(token => {
      this.spinner.show();
      const formData = new FormData();
      formData.append('type', this.contactEsnForm.get('type')?.value);
      formData.append('object', this.contactEsnForm.get('object')?.value);
      formData.append('subject', this.contactEsnForm.get('subject')?.value);
      formData.append('id', this.contactEsnForm.get('esn_id')?.value);     
      formData.append('recaptchaToken', token); 
      if(this.file){
        formData.append('file', this.file);
      }
      const formDataObject: { [key: string]: any } = {};
      formData.forEach((value, key) => {
        formDataObject[key] = value;
      });

      this.contactService
        .contactResponsable(formData)
        .pipe()
        .subscribe({
          next: (res) => {
            this.spinner.hide();
            this.toastrService.success(emailSended);
            this.router.navigateByUrl('/entreprises/list');
          },
          error: (err) => {
            this.spinner.hide();
            if (err?.error) {
              this.toastrService.error(
                "Cette entreprise n'a pas de responsable!"
              );
            }
          },
        });
      }).catch(err => {
          this.spinner.hide();
          this.toastrService.error('reCAPTCHA verification failed. Please try again.');
        });
  }
  get f() {
    return this.contactEsnForm.controls;
  }

  // onSelectChange(event: any) {
  //   console.log('Selected:', event);
  // }

  onReset() {
    this.submitted = false;
    this.contactEsnForm.reset({
      type: '',
      esn_id: this.idResponsable,
      user_id: this.id,
    });
    this.contactEsnForm.get('file')?.setValue('');
    this.contactEsnForm.get('type')?.setValue('');
  }
  getContactNames() {
    this.spinner.show();
     this.isspinner = true;
    this.contactService.getContactNamesByCandidat(this.idResponsable)
      .pipe(finalize(() => this.spinner.hide())
      )
      .subscribe(
        (res: any) => {
          if(res.status == 200) {
            this.listContactNames = res?.data?.data?.length > 0 ?  res?.data?.data : [{contactName : "Responsable de l'entreprise", id : 0}];
            this.isspinner = false;
          }

            
         

         
        },
        (error) => {
        }
      );
  }
}
